import React from 'react';
import { motion } from 'framer-motion';
import { Building, Users, Zap } from 'lucide-react';
const pillars = [{
  icon: Building,
  number: '01',
  title: 'Der Ort',
  description: 'Ein dediziertes Gebäude, ausgestattet für konzentriertes Arbeiten an KI-Projekten. Keine Großraumbüro-Ablenkung. Volle Infrastruktur. Whiteboards, GPU-Cloud-Zugang, Prototyping-Stationen.'
}, {
  icon: Users,
  number: '02',
  title: 'Die Experten',
  description: '5–10 erfahrene AI Engineers arbeiten permanent vor Ort. Sie haben Sprachmodelle auf Unternehmensdaten trainiert, automatische Bilderkennung für Qualitätskontrolle gebaut und intelligente Wissenssysteme entwickelt, die Mitarbeitern in Sekunden die richtige Antwort liefern. Branchenübergreifend. Praxiserprobt.'
}, {
  icon: Zap,
  number: '03',
  title: 'Der Prozess',
  description: 'Strukturierte 1–4 Wochen Sprints: Problem-Definition → Datenanalyse → Prototyping → Roadmap. Ihre Mitarbeiter arbeiten MIT, nicht nur ZU. Am Ende steht ein funktionierender Prototyp UND befähigte Mitarbeiter.'
}];
export function SolutionSection() {
  return <section id="konzept" className="py-24 md:py-32 bg-[#020611] border-t border-border relative overflow-hidden" data-id="element-287">
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-accent/5 rounded-full blur-[150px] pointer-events-none translate-x-1/3 -translate-y-1/3" data-id="element-288" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-289">
        <div className="max-w-3xl mb-20" data-id="element-290">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-6xl font-heading mb-6" data-id="element-291">
            Raus aus dem Büro.
            <br data-id="element-292" />
            <span className="text-accent italic" data-id="element-293">Rein in die Umsetzung.</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-muted leading-relaxed" data-id="element-294">
            Wir kombinieren einen physischen Ort, erfahrene Resident Engineers
            und einen strukturierten Sprint-Prozess zu einem Befähigungsprodukt,
            das Ihre Teams transformiert.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-295">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className="relative pt-8" data-id="element-296">
              <div className="absolute top-0 left-0 w-full h-[1px] bg-border" data-id="element-297">
                <div className="h-full bg-accent w-1/4" data-id="element-298" />
              </div>

              <div className="flex items-start justify-between mb-8" data-id="element-299">
                <div className="w-14 h-14 bg-surface border border-border flex items-center justify-center" data-id="element-300">
                  <pillar.icon className="text-accent" size={28} data-id="element-301" />
                </div>
                <span className="text-5xl font-heading font-light text-border-hover select-none" data-id="element-302">
                  {pillar.number}
                </span>
              </div>

              <h3 className="text-2xl font-heading font-semibold mb-4" data-id="element-303">
                {pillar.title}
              </h3>
              <p className="text-muted leading-relaxed" data-id="element-304">{pillar.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}